import { useQuery } from '@tanstack/react-query';
import { fetchQuestionBankSubjectDetail } from '../services/questionBankSubjectService';

export function useQuestionBankSubjectDetail(params = {}, options = {}) {
  return useQuery({
    queryKey: ['questionBankSubjectDetail', params],
    queryFn: async () => {
      const { payload } = await fetchQuestionBankSubjectDetail(params);
      const subjectDetail = payload?.subject_detail || null;

      return subjectDetail
        ? {
            ...subjectDetail,
            subjectDetail,
            topicVisibilityStatus: Number(
              payload?.topic_visibility_status ?? subjectDetail?.subject_topic_visibility_status ?? 0
            ),
            topicToggleStatus: Number(payload?.topic_toggle_status ?? subjectDetail?.topic_toggle_status ?? 0),
            forceTopicsEnabled: Number(payload?.force_topics_enabled ?? subjectDetail?.force_topics_enabled ?? 0),
            forceSubtopicsEnabled: Number(payload?.force_subtopics_enabled ?? subjectDetail?.force_subtopics_enabled ?? 0),
          }
        : null;
    },
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });
}
